import { instance } from './index';

// 리포트 목록 _ 유저
function reportUserList(data) {
  return instance.post(`api/reports/user`, data);
}

// 리포트 목록 _ 유저 _ 날짜별
function reportUserDaysList(id, data) {
  return instance.post(`api/reports/user/campaigns/${id}/days`, data);
}

// 리포트 목록 _ 유저 _ 매체별
function reportUserMediasList(id, mediaID, data) {
  return instance.post(
    `api/reports/user/campaigns/${id}/medias/${mediaID}`,
    data,
  );
}

// 리포트 목록 _ 유저 _ 매체별 _ 지면 날짜별
function reportUserMediasDaysList(id, mediaID, invenID, data) {
  return instance.post(
    `api/reports/user/campaigns/${id}/medias/${mediaID}/inventories/${invenID}/days`,
    data,
  );
}

// 리포트 목록 _ 관리자
function reportAdminList(data) {
  return instance.post(`api/reports/admin`, data);
}

// 리포트 목록 _ 관리자 _ 날짜별
function reportAdminDaysList(id, data) {
  return instance.post(`api/reports/admin/campaigns/${id}/days`, data);
}

// 리포트 목록 _ 관리자 _ 시간별
function reportAdminHoursList(id, dayID, data) {
  return instance.post(
    `api/reports/admin/campaigns/${id}/days/${dayID}/hours`,
    data,
  );
}

// 리포트 목록 _ 관리자 _ 매체별
function reportAdminMediasList(id, mediaID, data) {
  return instance.post(
    `api/reports/admin/campaigns/${id}/medias/${mediaID}`,
    data,
  );
}

// 리포트 목록 _ 관리자 _ 매체별 _ 지면 날짜별
function reportAdminMediasDaysList(id, mediaID, invenID, data) {
  return instance.post(
    `api/reports/admin/campaigns/${id}/medias/${mediaID}/inventories/${invenID}/days`,
    data,
  );
}

export {
  reportUserList,
  reportUserDaysList,
  reportUserMediasList,
  reportUserMediasDaysList,
  reportAdminList,
  reportAdminDaysList,
  reportAdminHoursList,
  reportAdminMediasList,
  reportAdminMediasDaysList,
};
